import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=13e6d10c&scoped=true&"
import script from "./UserItem.vue?vue&type=script&lang=js&"
export * from "./UserItem.vue?vue&type=script&lang=js&"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=13e6d10c&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e6d10c",
  null
  
)

export default component.exports